import React, { memo, useMemo } from 'react';
import { Icon, Text, createUseStyles, useTheme } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../../lib/Web5Context";
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'SummaryBox');
const SummaryBox = /*#__PURE__*/memo(_ref => {
  let {
    icon,
    text,
    iconColor,
    secondaryColor,
    text2,
    param
  } = _ref;
  const theme = useTheme();
  const {
    t
  } = useWeb5Context();
  const classes = useStyles();
  const getFinalLiteral = useMemo(() => {
    let literal;
    let secondParam;
    if (text2) {
      secondParam = t(text2, [param]);
      literal = t(text, [secondParam]);
      return literal;
    }
    return t(text);
  }, [param, t, text, text2]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.summaryBox
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: classes.icon
  }, /*#__PURE__*/React.createElement(Icon, {
    color: iconColor,
    size: "big",
    name: icon,
    overrides: {
      icon: {
        secondaryColor: secondaryColor
      }
    }
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    type: "subtitle1",
    color: theme.colors.textLight.secondary
  }, getFinalLiteral)));
});
export default SummaryBox;